module.exports = __webpack_public_path__ + "static/media/m-tv-shows-banner.747ae285.svg";